'use strict';
const angular = require('angular');

export class ContactLookupSsComponent {
  /*@ngInject*/
  constructor(ContactService, DTOptionsBuilder, DTColumnBuilder, $timeout) {
    this.ContactService = ContactService;
    this.DTOptionsBuilder = DTOptionsBuilder;
    this.DTColumnBuilder = DTColumnBuilder;
    this.dtInstance = {};
    this.$timeout = $timeout;

    this.data = [];

    this.valueMap = {
      composedNameHtml: {},
      primaryAddressHtml: {},
      primaryPhone: {},
      primaryEmail: {},
      primaryEmailHtml: {}
    };

    this.selected = {};
  }

  $onInit() {
    this.config = this.resolve.config;
    const that = this;
      this.dtColumns = [
        //here We will add .withOption('name','column_name') for send column name to the server
        this.DTColumnBuilder.newColumn("lastName", "Name").withOption('name', 'Name')
        //DTColumnBuilder.newColumn("firstName", "First").withOption('name', 'First'),
        //DTColumnBuilder.newColumn("lastName", "Last").withOption('name', 'Last')
      ];

      this.dtOptions = this.DTOptionsBuilder.newOptions()
        .withOption('serverSide', true)
        .withOption('pagingType', 'full_numbers')
        .withOption('pageLength', 10)
        .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
        .withOption('ajax', (params, cb) => {

          if (params.search) {
            if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
              return;

            params.search.fields = ["lastName, firstName", "firstName", "lastName", "address.street", "email.address"];
          }

          that.ContactService.queryDT(params, result => {
            if (params.search && params.search.value) {
              let searchTerms = params.search.value.split(",").map(t => t.trim());
              that.buildValueMap(result.data, true, searchTerms);
            } else {
              that.buildValueMap(result.data);
            }

            that.data = result.data;

            cb({
              recordsTotal: result.recordsTotal,
              recordsFiltered: result.recordsFiltered,
              data: []
            });

            that.$timeout(_=>{
              $('#dtContacts').DataTable().columns.adjust();
            }, 0);
          })
        });

  }

  buildValueMap(data, highlight, searchTerms) {
    data.forEach(contact => {
      this.valueMap.composedNameHtml[contact._id] = this.getComposedName(contact);
      this.valueMap.primaryAddressHtml[contact._id] = this.getPrimaryAddress(contact);
      this.valueMap.primaryPhone[contact._id] = this.getPrimaryPhone(contact);
      this.valueMap.primaryEmail[contact._id] = this.getPrimaryEmail(contact);
      this.valueMap.primaryEmailHtml[contact._id] = this.getPrimaryEmailSoftBreak(contact);

      if (highlight && searchTerms && searchTerms.length) {
        searchTerms.sort(function(a, b) {
          return b.length - a.length;
        });

        var regexFirst = new RegExp(searchTerms[0], 'i');
        var regexAll = new RegExp('(' + searchTerms.join('|') + ')', 'gi');

        this.valueMap.composedNameHtml[contact._id] = this.valueMap.composedNameHtml[contact._id].replace(regexAll, '<b>$&</b>');
        this.valueMap.primaryAddressHtml[contact._id] = this.valueMap.primaryAddressHtml[contact._id].replace(regexFirst, '<b>$&</b>');
        this.valueMap.primaryEmailHtml[contact._id] = this.valueMap.primaryEmailHtml[contact._id].replace(regexFirst, '<b>$&</b>');
      }
    });
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName = "-, -";

      composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }


  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryEmailSoftBreak(contact) {
    let email = this.getPrimaryEmail(contact);

    return email
      .replace('@','@&#8203;')
      .replace('.','&#8203;.')
      .replace('-','-&#8203;')
      .replace('_','_&#8203;');
  }

  getPrimaryPhone(contact) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }

  ok(contact) {
    this.close({$value: contact});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.contactLookupSS', [])
  .component('contactLookupSs', {
    template: require('./contact-lookup-ss.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ContactLookupSsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/contact-lookup-ss/contact-lookup-ss.component.js